import {EnvironmentType,} from '@models/system-vo/environment-type';
import {LogLevel,} from '@models/index';

// OFI AWS Staging(検証)環境のConfig
export const environment = {
  production: false,
  type: EnvironmentType.STAGING,
  log_level: LogLevel.DEBUG,
  output_method_log: true,
  server_host: 'https://stg-lb.ivar-ofi.jp:8080',
  ignore_client_validation_for_testing: false,
  endpoint: {
    api: '/sms/api',
  },
};
